import { render, staticRenderFns } from "./PaymentOptions.vue?vue&type=template&id=b1456528&scoped=true&"
import script from "./PaymentOptions.vue?vue&type=script&lang=ts&"
export * from "./PaymentOptions.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentOptions.vue?vue&type=style&index=0&id=b1456528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1456528",
  null
  
)

export default component.exports